import React, {
  useMemo 
} from "react";
import classes from "./mobileFilter.module.css";
import MobileFilterModal from "./mobileFilterModal";
import useMobileFilter from "./useMobileFilter";

const MobileFilter = (props) => {
  const {
    colors,
    categories,
    selectedColorIds: propsSelectedColorIds,
    selectedCategoryId: propsSelectedCategoryId
  } = props;

  const talonProps = useMobileFilter(props);

  const {
    onFilterItemClick,
    mobileFilterModalVisible,
    setMobileFilterModalVisible,
    selectedColorIds,
    setSelectedColorIds,
    selectedCategoryId,
    setSelectedCategoryId,
    onApply
  } = talonProps;

  const categoryLabel = useMemo(() => {
    if (!selectedCategoryId) {
      return "Catogory";
    }

    const find = categories.find((temp) => temp.ids === selectedCategoryId);

    return find.label;
  }, [categories, selectedCategoryId]);

  const colorLabel = useMemo(() => {
    if (!selectedColorIds) {
      return "Color";
    }

    const find = colors.find((temp) => temp.ids === selectedColorIds);

    return find.label;
  }, [categories, selectedColorIds]);

  return (
    <div className={classes.root}>
      <div className={classes.filterItem} onClick={onFilterItemClick}>
        <span>{categoryLabel}</span>
        <span className={classes.icon} />
      </div>
      <div className={classes.filterItem} onClick={onFilterItemClick}>
        <span>{colorLabel}</span>
        <span className={classes.icon} />
      </div>

      <MobileFilterModal
        isOpen={mobileFilterModalVisible}
        onClose={() => {
          setMobileFilterModalVisible(false);
        }}
        selectedColorIds={selectedColorIds}
        setSelectedColorIds={setSelectedColorIds}
        selectedCategoryId={selectedCategoryId}
        setSelectedCategoryId={setSelectedCategoryId}
        colors={colors}
        categories={categories}
        onApply={onApply}
      />
    </div>
  );
};

export default MobileFilter;
